export default __webpack_public_path__ + "static/media/zrogowacenia3.340a0e24.jpg";